export const fontsSize = {
    normal: "1rem",
    big: "1.5rem",
    large: "2rem",
};

export type FontsSizeTypes = keyof typeof fontsSize;

export const fontSizeButtons: {
    value: keyof typeof fontsSize;
    label: string;
    textSize: string;
}[] = [
    {
        value: "normal",
        label: "font_size_normal",
        textSize: "16px",
    },
    {
        value: "big",
        label: "font_size_big",
        textSize: "20px",
    },
    {
        value: "large",
        label: "font_size_large",
        textSize: "24px",
    },
];
